import { NextPage } from 'next'
import styles from './_artistPage.module.scss'
import { ARTISTS_LIST_QUERY, ARTIST_DETAILS_QUERY } from '../../../gql'
import { staticPath, staticProps } from '../../../utils/createApolloClient'
import ArtistLayout from './components/ArtistLayout'
import { useRouter } from 'next/router'
import { artistSongsPath } from '../../../utils/routeHelpers'
import { useEffect } from 'react'
import { Artist } from '../../../__generated__/graphql'

const ArtistSongsPage: NextPage<{ artist: Artist }> = ({ artist }) => {
  const router = useRouter()
  if (!artist) return <></>

  useEffect(() => {
    if (!artist.description) router.push(artistSongsPath(artist))
  }, [])

  const cleanArtistBio = () => {
    return { __html: artist.description }
  }

  return (
    <ArtistLayout artist={artist}>
      <div
        className={
          artist.description ? styles.artistAbout : styles.emptyArtistAbout
        }
        dangerouslySetInnerHTML={cleanArtistBio()}
      />
    </ArtistLayout>
  )
}

export const getStaticPaths = staticPath({
  additionalPaths: async ({ client }) => {
    const { data } = await client.query({
      query: ARTISTS_LIST_QUERY
    })

    const paths = data.artists.map((artist) => ({
      params: { id: artist.id.toString() }
    }))

    return {
      paths,
      fallback: true
    }
  }
})

export const getStaticProps = staticProps({
  additionalProps: async ({ client, ctx }) => {
    const {
      data: { artist }
    } = await client.query({
      query: ARTIST_DETAILS_QUERY,
      variables: { id: Number(ctx.params.id) }
    })

    return {
      artist
    }
  }
})

export default ArtistSongsPage
